import React from 'react'
import ClipLoader from 'react-spinners/ClipLoader'

const Spinner = ({dark = false}) => {
    const color = dark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)';
    return <ClipLoader color={color} margin='auto'/>;
};

export default Spinner;